import { AtendimentoType } from '_metronic/helpers'
import { createListFilters, IOption } from 'app/components'

/** Filtros da barra. A aba (valores atuais/histórico) fica fora: sempre há uma selecionada. */
export type EmpresaValoresFilters = {
  tipoAtendimento?: IOption<AtendimentoType>
  especialidade?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<EmpresaValoresFilters>({
  tipoAtendimento: undefined,
  especialidade: undefined,
})
